<template>
  <div class="create-password-container">
    <Language/>
    <div class="title">{{ $t('hm.label.createPassword') }}</div>
    <div class="input-form-div" :class="isPc ? 'pc' : 'mobile'">
        <SimpleForm
          ref="SimpleForm"
          :model="accountInfo"
          :formLines="formLines"
          :formStyle="formStyle"
          :labelWidth="labelWidth"
          labelPosition="left"
          :hideRequiredAsterisk="true"
          :messageInline="true"
          @submit="submitPassword"
        >
          <template #email>
            <el-input v-model="accountInfo.email" disabled/>
          </template>
          <template #firstName>
            <el-input v-model="accountInfo.firstName" disabled/>
          </template>
          <template #lastName>
            <el-input v-model="accountInfo.lastName" disabled/>
          </template>
        </SimpleForm>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import SimpleForm from '@/components/formEditor/simpleForm.vue'
import Language from './language.vue'
import mixin from './mixin'
import { passwordEncrypt } from '@/utils/rsa'

export default {
  mixins: [mixin],
  components: {
    SimpleForm, Language
  },
  data () {
    return {
      accountInfo: {
        email: '',
        resetCode: '',
        firstName: '',
        lastName: '',
        password: '',
        rePassword: ''
      },
      rePasswordError: '',
      regexValue: '^(?![0-9_#@.-]+$)(?![a-zA-Z_#@.-]+$)(?![0-9a-z_#@.-]+$)(?![0-9A-Z_#@.-]+$)[0-9a-zA-Z_#@.-]{10,}$',
      languageOptions: [{ id: 'zh', text: '简体中文' }, { id: 'en', text: 'English' }]
    }
  },
  computed: {
    policyModal () {
      return {
        title: this.$t('onboarding.nestle.statementTitle'),
        body: this.$t('onboarding.nestle.statementBody')
      }
    },
    formLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      const passwordCheck = (rule, value, callback) => {
        if (this.regexValue) {
          const pattern = new RegExp(this.regexValue)
          if (!value) {
            callback(new Error(requiredMessage))
          } else if (!pattern.test(value)) {
            callback(new Error(this.$t('common.message.invalidPwd')))
          }
        } else {
          this.form.validateField('checkPass')
        }
        callback()
      }
      const rePasswordCheck = (rule, value, callback) => {
        if (this.accountInfo.rePassword !== this.accountInfo.password) {
          callback(new Error(this.$t('common.message.passwordNotSame')))
        } else {
          this.form.validateField('checkPass')
        }
        callback()
      }
      return {
        email: {
          contentSlot: 'email',
          label: this.$t('hm.label.userName'),
          rules: [
            { required: true, message: requiredMessage, trigger: 'blur' }
          ]
        },
        firstName: {
          contentSlot: 'firstName',
          label: this.$t('hm.label.firstName')
        },
        lastName: {
          contentSlot: 'lastName',
          label: this.$t('hm.label.lastName')
        },
        password: {
          type: 'password',
          label: this.$t('hm.label.password'),
          rules: [
            { required: true, validator: passwordCheck, trigger: 'blur' }
          ]
        },
        rePassword: {
          type: 'password',
          label: this.$t('hm.label.rePassword'),
          rules: [
            { required: true, validator: rePasswordCheck, trigger: 'blur' }
          ]
        },
        submitBtn: {
          type: 'submitBtn',
          class: 'submit-btn-container',
          btnText: this.$t('hm.btn.submit')
        }
      }
    },
    formStyle () {
      return { width: '100%' }
    },
    labelWidth () {
      return this.$i18n.locale === 'zh' ? '30%' : '38%'
    },
    form () {
      return this.$refs.SimpleForm.form
    }
  },
  created () {
    this.getLoginInfo()
  },
  methods: {
    ...mapActions('hm', ['getHmInfoByResetCode', 'createHmPassword', 'setToken']),
    async getLoginInfo () {
      const resp = await this.getHmInfoByResetCode(this.$route.params.resetCode)
      if (resp) {
        this.accountInfo.firstName = resp.first_name || ''
        this.accountInfo.lastName = resp.last_name || ''
        this.accountInfo.email = resp.email_address || ''
      }
    },
    async submitPassword (isValid) {
      if (!isValid) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        if (!this.resetCode) {
          const formData = {
            reset_code: this.$route.params.resetCode,
            password: passwordEncrypt(this.accountInfo.password)
          }
          const resp = await this.createHmPassword({ resetCode: this.$route.params.resetCode, formData })
          if (resp) {
            this.$router.push({ name: 'hm-dashboard' })
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.create-password-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .title {
    font-weight: bolder;
    text-align: center;
    font-size: 24px;
    margin: 2em 0 4em 0;
  }

  .input-form-div {
    min-width: 350px;

    &.pc {
      width: 450px;
    }

    ::v-deep .submit-btn-container {
      .el-form-item__content {
        margin-left: 30%;
        width: 70%;
      }

      .submit-btn {
        background-color: #f63;
        border: 0;
        color: #FFFFFF;
        font-size: 16px;
        margin-top: 70px;
        width: 57%;

        &:hover {
          color: #FFFFFF;
        }
      }
    }

    ::v-deep .el-form-item__label {
      font-size: 15px;
    }

    &.mobile {
      ::v-deep .el-form-item__label {
        font-size: 12px;
      }
    }
  }
}
</style>
